<template>
  <div id="login-body">
    <!--logo-->
    <a-row>
      <a-col>
        <div class="login-content-wrapper logo-wrapper">
          <div style="display: flex; cursor: pointer">
            <span class="logo-img" v-if="platForm.logoImg">
              <img
                :alt="platForm.alt"
                :src="require(`@/assets${platForm.logoImg}`)"
              />
            </span>
            <div v-if="platForm.showName" class="logo-text">
              <span class="platformName">{{ platForm.platformName }}</span>
              <span>{{ platForm.alt }}</span>
            </div>
          </div>
          <span id="test" v-if="platForm.logoImg"></span>
          <span class="logo-font">欢迎登录</span>
        </div>
      </a-col>
    </a-row>

    <!--登录框-->
    <a-row>
      <a-col>
        <div class="login-bg">
          <div class="login-content-wrapper">
            <div class="login-form-container clearfix">
              <div class="login-form-wrapper-bg">
                <div class="bg"></div>
              </div>
              <div class="login-form-wrapper">
                <a-form
                  :form="form"
                  layout="vertical"
                  class="input-box"
                  @submit="handleSubmit"
                  :hideRequiredMark="true"
                >
                  <div v-show="!CALogin">
                    <a-form-item label="角色：" class="login-form-item">
                      <a-select
                        style="width: 100%"
                        class="login-form-input"
                        placeholder="请选择"
                        v-decorator="[
                          'tenant',
                          {
                            rules: [{ required: true, message: '请选择角色' }],
                          },
                        ]"
                        @change="handleChange"
                      >
                        <a-select-option
                          v-for="item in roles"
                          :value="item.id"
                          :key="item.id"
                          >{{ item.name }}</a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item label="账号：" class="login-form-item">
                      <a-input
                        class="login-form-input"
                        v-decorator="[
                          'username',
                          {
                            rules: [
                              {
                                required: true,
                                message: '请输入帐户名',
                              },
                            ],
                            validateTrigger: 'change',
                          },
                        ]"
                      />
                    </a-form-item>
                    <a-form-item label="密码：" class="login-form-item">
                      <a-input
                        class="login-form-input"
                        autocomplete="false"
                        v-decorator="[
                          'password',
                          {
                            rules: [{ required: true, message: '请输入密码' }],
                            validateTrigger: 'change',
                          },
                        ]"
                        type="password"
                      />
                    </a-form-item>
                  </div>
                  <div v-show="CALogin" class="caLogin-wrap">
                    <a-spin :spinning="scanLoginLoading">
                      <img
                        @click="scanLogin"
                        alt="example"
                        :src="scanLoginImageUrl"
                      />
                    </a-spin>
                  </div>
                  <a-form-item class="login-form-item">
                    <a-checkbox
                      v-decorator="[
                        'rememberMe',
                        {
                          valuePropName: 'checked',
                          initialValue: true,
                        },
                      ]"
                    >
                      记住密码
                    </a-checkbox>
                    <a
                      class="login-form-forgot"
                      href="javascript:;"
                      @click="
                        modalVisible = true;
                        $refs.findPassword.isVerified = false;
                      "
                    >
                      找回密码
                    </a>
                    <a-button
                      id="btn"
                      html-type="submit"
                      class="login-form-button"
                      :loading="submitBtnLoading"
                      :disabled="submitBtnLoading"
                    >
                      登录
                    </a-button>
                    <a-divider>or</a-divider>
                    <span>
                      没有账号?
                      <a href="javascript:;" @click="goRegister">立即注册</a>
                      <!-- <a
                        v-if="platForm.showOperationGuide"
                        href="javascript:;"
                        @click="downloadOperationGuide"
                        style="margin-left: 20px"
                      >
                        操作指引
                      </a> -->
                    </span>
                  </a-form-item>
                </a-form>
              </div>
            </div>
          </div>
        </div>
      </a-col>
    </a-row>
    <!-- 找回密码 -->
    <find-password
      ref="findPassword"
      :modal-visible="modalVisible"
      @modal-close="modalVisible = false"
    />
    <!-- 操作指引 -->
    <OperationGuideModal
      v-model="showOperationGuideModal"
      :platForm="platForm"
    />
  </div>
</template>

<script>
import OperationGuideModal from "./OperationGuideModal";
import FindPassword from "./findPassword";
import {
  userCenterGetAllWithoutToken,
  userCenterGetTokenBySerialNo,
} from "@/api/user";
import {
  ALoginJumpPage,
  getATenantList,
  GetByProviderKey,
  bAxios,
  ALoginSuccess,
  ADotnetLogin,
} from "@/api/login";
import {
  getGlobalUrl,
  setWindowGlobalUrl,
} from "@/utils/axios";
import {
  userCenterRegisterWihtNoCode,
  platfromCenterRegister,
  platfromCenterGetTenantPage,
} from "@/api/register";
import { mapActions } from "vuex";
import { getQRCodeLoginInfo } from "@/api/CAapi";
import { platFormlogoImageMap, getPlatFormlogoImageMap } from "@/config/dict";
import { getUserName } from "@/utils/userCenter";
import { getUrlParams } from "@/utils/util";
import { A_TENANT_ID, A_ACCESS_TOKEN, REGISTER_TENANT_ID, A_DOTNET_ACCESS_TOKEN } from '@/store/mutation-types'
import axios from 'axios'
// const redirectUri = encodeURIComponent('https://qy.choicelink.cn:8440')

// 云采链测试
const wxAppid = 'wwf7dcff22dd759a83'
const wxAgentid = '1000026'

// 采联正式数据
// const wxAppid = "wx003757ee144cae06";
export default {
  name: "Login",
  components: {
    OperationGuideModal,
    FindPassword,
  },
  data() {
    return {
      form: this.$form.createForm(this),
      roles: [],
      showOperationGuideModal: false, // 操作指引弹框是否显示
      submitBtnLoading: false,
      modalVisible: false, // 找回密码弹框是否可见
      CALogin: false,
      scanLoginLoading: false,
      scanLoginImageUrl: null,
      scanImagetId: null,
      timer: null,
      platFormlogoImageMap: platFormlogoImageMap,
      platForm: {},
    };
  },
  computed: {
    pathname() {
      return location.pathname;
    },
    queryTenantID() {
      return this.$route?.query?.tenantId || "";
    },
  },
  watch: {
    queryTenantID: {
      async handler(val) {
        if (val) {
          this.platForm = await getPlatFormlogoImageMap(val);
        }
      },
      immediate: true,
    },
  },
  created() {
    // 企业微信登陆设定
    const { wxWork, tenancyName, authProvider, appName, tenantId } = this.getUrlParams()
    const wxRedirectUri = `${encodeURIComponent('http://ys.choicelink.cn:8351')}?tenantId=${tenantId}`
    if (wxWork) {
      // 微信登录回调根据state确定租户
      const loginUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${wxAppid}&redirect_uri=${wxRedirectUri}&response_type=code&scope=snsapi_privateinfo&state=${tenancyName},${appName},${authProvider}&agentid=${wxAgentid}#wechat_redirect`
      window.location.href = loginUrl
    }
    this.getTenant()
  },
  mounted() {
    const { getUrlParams, WxWorkAuthorizationLogin } = this
    // 如果有code跳转自动登陆
    const { code, state, tenantId } = getUrlParams()
    // 微信登陆跳转
    if (code && state) {
      this.submitBtnLoading = true
      // 默认代理机构角色
      this.$ls.set(A_TENANT_ID, 3)
      WxWorkAuthorizationLogin({
        authProvider: 'YunCaiLianTest',
        providerAccessCode: code,
        companyName: '云采链(广州)信息科技有限公司',
        tenantId: '3',
        btenantId: tenantId
      })
        .then(async (res) => {
          console.log(res)
          const { aTenantId, aToken } = res
          const headers = {
            'Abp.TenantId': aTenantId,
            Authorization: `Bearer ${aToken}`
          }
          const userCenterUrl = await getGlobalUrl('userCenterUrl')
          const mainUrl = window.urlConfig.webs.mainUrl
          const aInfoRes = await axios({
            url: userCenterUrl + '/api/services/app/Session/GetCurrentLoginInformations',
            method: 'get',
            headers
          })
          if (aInfoRes.data.success) {
            const aUserTotalInfo = aInfoRes.data.result
            // 判断是否已入库平台
            const tenancyName = state.split(',')[0]
            const authProvider = state.split(',')[2]
            // 是否已授权平台，已授权平台直接登陆
            const hasAuthRep = await GetByProviderKey({
              isActiveFilter: false,
              providerKey: aUserTotalInfo.user.id,
              filter: `t.tenancyName == "${tenancyName}"`
            })
            const authPlat = hasAuthRep.result.items[0]
            const userCenterHref = window.urlConfig.webs.userCenterUrl
            if (!authPlat) {
              // 未有授权，创建授权跳转
              // 创建授权账号
              await bAxios.post('/api/TokenAuth/RegisterGetAnyUserAsync', {
                needAudit: false,
                tenancyName,
                roleName: '代理机构',
                userInfo: {
                  provider: aUserTotalInfo.tenant.id,
                  providerKey: aUserTotalInfo.user.id,
                  userName: aUserTotalInfo.user.userName,
                  name: aUserTotalInfo.user.name,
                  surname: aUserTotalInfo.user.surname,
                  emailAddress: aUserTotalInfo.user.emailAddress,
                  phoneNumber: aUserTotalInfo.user.phoneNumber,
                  companyId: aUserTotalInfo.user.companyId,
                  companyName: aUserTotalInfo.user.companyName
                }
              })
            }
            // 获取token跳转
            location.href = `${mainUrl}?token=${this.$ls.get(A_ACCESS_TOKEN)}&tId=${aUserTotalInfo.tenant.id}&redirectUrl=${userCenterHref}`
          } else {
            this.$message.erorr('发生未知错误，请稍后再试')
          }
        })
        .catch(err => this.requestFailed(err))
        .finally(() => {
          this.submitBtnLoading = false
        })
    }
  },
  methods: {
    // CA登录
    async CAScanLogin(CAInfo) {
      console.log(CAInfo);
      if (CAInfo.loginUserType !== "02") {
        // 如果不是使用单位进行扫码登录的话，进行提示 !!这个重要
        this.$message.warning("请使用单位证书进行扫码登录");
        return;
      }
      let tenantRes = null;
      // 从链接上获取需要注册的平台信息
      if (!this.$route.query.tenantId) {
        this.$message.warning("获取平台信息失败");
        return;
      } else {
        tenantRes = await platfromCenterGetTenantPage({
          filter: `id == "${this.$route.query.tenantId}"`,
          pageNum: 1,
          pageSize: 99,
        });
        if (tenantRes.success && tenantRes.result.totalCount > 0) {
          tenantRes = tenantRes.result.items[0];
        } else {
          this.$message.warning("获取平台信息失败");
          return;
        }
      }
      // 根据unifiedTransactionCode （机构代码）、personalTransactionCode（个人码）去userCenter的user中查询是否有serialNo 为 unifiedTransactionCode_personalTransactionCode（换成对应变量值）的用户
      // 有则代表该用户已经使用过CA扫码登录，则直接调用接口获取token进行登录。
      // 若未找到对应用户，则代表该用户是第一次CA扫码登录，需要进行注册操作。
      try {
        const serialNo = `${CAInfo.unifiedTransactionCode}_${CAInfo.personalTransactionCode}`;
        const userRes = await userCenterGetAllWithoutToken({
          filter: `serialNo == "${serialNo}"`,
          isActive: true,
          pageNum: 1,
          pageSize: 99,
        });
        if (userRes.success) {
          if (userRes.result.items && userRes.result.items.length > 0) {
            const userInfo = userRes.result.items[0];
            // 判断这个用户是否已经入库地址路径上对应的tenantId 的平台。已入库则直接执行跳转，未入库则执行入库操作
            const hasAuthRep = await GetByProviderKey({
              isActiveFilter: false,
              providerKey: userInfo.id,
              filter: `t.tenancyName == "${tenantRes.tenancyName}"`,
            });
            if (hasAuthRep.success && hasAuthRep.result.totalCount === 0) {
              // 执行入库
              // 注册b用户
              const bUserParams = {
                needAudit: true,
                roleName: "供应商",
                tenancyName: tenantRes.tenancyName,
                userInfo: {
                  companyId: userInfo.companyId,
                  companyName: CAInfo.legalName,
                  emailAddress: CAInfo.telephoneNum + "@qq.com", // 暂时乱写，一定要是邮箱格式不然后端接口会报错
                  name: CAInfo.personName,
                  phoneNumber: CAInfo.telephoneNum,
                  provider: 2,
                  providerKey: userInfo.id,
                  surname: CAInfo.personName,
                  userName:
                    CAInfo.unifiedTransactionCode.slice(-4) +
                    "_" +
                    CAInfo.idCard,
                },
              };
              // 注册B用户
              await platfromCenterRegister(bUserParams);
            }
            console.log(userInfo);
            // 通过 serialNo 获取用户的token
            const tokenRes = await userCenterGetTokenBySerialNo({
              serialNo,
            });
            if (tokenRes.success) {
              // 执行跳转
              ALoginSuccess(tokenRes.result, 2);
            } else {
              this.$message.error("CA登录失败，请重新扫码登录");
              this.scanLogin();
            }
          } else {
            // 校验userName 是否已存在
            const userName =
              CAInfo.unifiedTransactionCode.slice(-4) + "_" + CAInfo.idCard; // 暂时设置是机构代理后4位+身份证号码
            console.log(tenantRes);
            // 1、正常创建A的用户 2、创建B用户，isActive为false，并且需要创建userAudit数据，里面的status 0待审核，1拒绝，2同意
            this.$spin.show("正在注册账号，请稍候...");
            const parameter = {
              caType: "2", // 2为扫码ca
              serialNo,
              name: CAInfo.personName,
              surname: CAInfo.personName,
              userName,
              emailAddress: CAInfo.telephoneNum + "@qq.com", // 暂时乱写，一定要是邮箱格式不然后端接口会报错
              password: CAInfo.idCard.slice(-6), // 手机号码默认后六位
              phoneNumber: CAInfo.telephoneNum,
              isActive: true,
              registerEntry: "4.0供应商CA扫码注册",
              companyInput: {
                companyName: CAInfo.legalName,
                companyNo: CAInfo.legalName,
              },
            };
            const userRep = await userCenterRegisterWihtNoCode(parameter, 2); // 注册为供应商
            if (!userRep.success || !userRep.result.msg) {
              this.$message.error("初始化账号数据失败");
              return;
            }
            console.log(userRep);
            //  注册b用户
            const bUserParams = {
              needAudit: true,
              roleName: "供应商",
              tenancyName: tenantRes.tenancyName,
              userInfo: {
                companyId: userRep.result.companyId,
                companyName: CAInfo.legalName,
                emailAddress: CAInfo.telephoneNum + "@qq.com", // 暂时乱写，一定要是邮箱格式不然后端接口会报错
                name: CAInfo.personName,
                phoneNumber: CAInfo.telephoneNum,
                provider: 2,
                providerKey: userRep.result.msg,
                surname: CAInfo.personName,
                userName:
                  CAInfo.unifiedTransactionCode.slice(-4) + "_" + CAInfo.idCard,
              },
            };
            // 注册B用户
            await platfromCenterRegister(bUserParams);
            // a，b都注册成功以后，利用a的Id获取token然后跳转
            const tokenRes = await userCenterGetTokenBySerialNo({
              serialNo,
            });
            if (tokenRes.success) {
              // 执行跳转
              ALoginSuccess(tokenRes.result, 2);
            } else {
              this.$message.error("CA登录失败，请重新扫码登录");
              this.scanLogin();
            }
          }
        } else {
          this.$message.error("CA登录失败，请重新扫码登录");
          this.scanLogin();
        }
      } catch (error) {
        console.error(error);
        this.$message.error("发生未知错误");
      }
    },
    // 获取二维码
    async scanLogin() {
      if (this.timer) {
        this.stopPoll();
      }
      this.scanLoginLoading = true;
      const res = await getQRCodeContent();
      if (res.header.returnCode === "0") {
        this.scanLoginImageUrl =
          "data:image/png;base64," + res.data.qrCodeImageBase64;
        this.scanImagetId = res.data.tid;
        this.scanLoginLoading = false;
        this.startPoll(); // 开始轮询获取用户信息
      } else {
        this.$message.error("获取二维码失败");
      }
      console.log(res);
    },
    // 开始轮询获取用户信息
    async startPoll() {
      const { header, data } = await getQRCodeLoginInfo(this.scanImagetId);
      if (header.returnCode === "0") {
        // this.$ls.set(CA_LOGIN_IMAGE_TID, this.scanImagetId)
        this.CAScanLogin(data);
        this.stopPoll(); // 停止轮询
        return;
      }
      this.timer = setTimeout(this.startPoll, 2000);
    },
    // 停止轮询
    stopPoll() {
      clearTimeout(this.timer);
    },
    ...mapActions(["WxWorkAuthorizationLogin"]),
    changeCALogin() {
      this.CALogin = true;
      this.scanLogin();
    },
    userNameLogin() {
      this.CALogin = false;
      this.stopPoll();
    },
    getUrlParams() {
      const url = location.search;
      const requestParams = {};
      if (url.indexOf("?") !== -1) {
        const str = url.substr(1);
        const strs = str.split("&");
        for (let i = 0; i < strs.length; i++) {
          requestParams[strs[i].split("=")[0]] = decodeURIComponent(
            strs[i].split("=")[1]
          );
        }
      }
      return requestParams;
    },
    requestFailed(err) {
      this.$notification.error({
        message: "错误",
        description:
          (((err.response || {}).data || {}).error || {}).message ||
          "请求出现错误，请稍后再试",
        duration: 4,
      });
    },
    goRegister() {
      this.$router.push({
        path: "/register",
        query: { tenantId: this.$route.query.tenantId },
      });
    },
    handleSubmit(e) {
      e.preventDefault();
      const {
        form: { validateFields },
      } = this;

      const validateFieldsKey = [
        "tenant",
        "username",
        "password",
        "rememberMe",
      ];

      validateFields(validateFieldsKey, async (err, values) => {
        if (!err) {
          this.submitBtnLoading = true;
          try {
            await ALoginJumpPage(
              {
                userNameOrEmailAddress: getUserName(values.username, "登陆"),
                password: values.password,
              },
              values.tenant
            ); // A 登录并跳转页面
          } catch (err) {
            console.log("err", values.username);
            this.$notification.error({
              message: "错误",
              description: err?.message,
              duration: 4,
            });
          }
          this.submitBtnLoading = false;
        }
      });
    },
    async getTenant() {
      // 获取授权平台列表
      const { result } = await getATenantList();
      let roles = [];
      roles = result.items.filter((obj) => {
        return obj.name !== "Default";
      });
      roles.push({
        id: "sjy",
        name: "纪检审计",
        tenancyName: "sjy",
      });
      // 排序
      const sortList = [
        "采购人",
        "供应商",
        "专家",
        "代理机构",
        "审核人",
        "纪检审计",
      ];
      sortList.forEach((sort) => {
        this.roles.push(roles.filter((item) => item.name === sort)[0]);
      });
      const showRole = ["采购人", "供应商", "专家", "代理机构"];
      this.roles = this.roles.filter(
        (item) => showRole.indexOf(item.name) !== -1
      );
    },
    handleChange(val) {
      this.$emit("selectRoleOk", val);
    },
    toHomePage(link) {
      if (link) {
        location.href = link;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "./rewrite-antd-style.less";
@blue: #1890ff;
@labelColor: #fff;
@contentWidth: 1230px;
@fontSize: 12px;

.warning-tips {
  line-height: 18px;
  width: @contentWidth;
  margin: 0 auto;
}
.login-bg {
  height: 638px;
  position: relative;
  background-color: #eef6ff;
}
.logo-wrapper {
  display: flex;
  flex-direction: row;
  line-height: 120px;
  background-color: @labelColor;
  height: 124px;
}
.logo-img > img {
  // width: 200px;
  height: 70px;
}
.logo-text {
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-left: 20px;
  font-size: 18px;
  line-height: 28px;
  font-weight: 600;
  .platformName {
    font-size: 25px;
    margin-bottom: 5px;
  }
}
#test:after {
  content: "";
  height: 48px;
  width: 1px;
  background: #d8d8d8;
  display: inline-block;
  vertical-align: middle;
  margin: 0 29px;
}
.logo-font {
  padding-left: 20px;
  font-size: 30px;
  color: #2c3e50;
  vertical-align: middle;
}
.login-content-wrapper {
  margin: 0 auto;
  width: @contentWidth;
  position: relative;
}
.login-form-container {
  height: 638px;
  .login-form-wrapper-bg {
    position: absolute;
    width: 958px;
    height: 410px;
    top: 50%;
    left: 50%;
    margin-left: -480px;
    margin-top: -140px;
    .bg {
      width: 100%;
      height: 410px;
      background: url("./images/bg-login.png") no-repeat;
      transform: scale(0.98);
    }
  }
  .login-form-wrapper {
    position: relative;
    height: 460px;
    width: 420px;
    // float: right;
    border-radius: 20px;
    margin: 0 auto;
    top: 50%;
    transform: translate(0, -50%);
    background: url("./images/bg-sm.png") no-repeat;
    padding: 45px 55px;
    .caLogin-wrap {
      width: 100%;
      height: 255px;
      /deep/.ant-spin-container {
        display: flex;
        justify-content: center;
        img {
          cursor: pointer;
          width: 230px;
          height: 230px;
        }
      }
    }
    .login-form-item {
      height: 83px;
      margin-bottom: 2px;
      .login-form-input {
        height: 36px;
      }
      .login-form-forgot {
        float: right;
        color: @labelColor;
      }
      .ant-checkbox-wrapper {
        color: @labelColor;
      }
      .login-form-button {
        width: 100%;
        height: 40px;
        margin-top: 10px;
      }
      .ant-divider {
        color: #999;
        font-weight: lighter;
      }
      span {
        display: block;
        width: 100%;
        color: @labelColor;
        text-align: center;
      }
    }
  }
}
.footer-wrapper {
  background: #fff;
  padding: 30px 0;
  .content-warpper {
    width: 1200px;
    margin: 0 auto;
  }
  .copyright-wrapper {
    .copyright-info {
      display: inline-block;
      vertical-align: top;
      text-align: left;
      width: 580px;
      line-height: 24px;
      color: #333;
      margin-top: 10px;
      margin-left: 50px;
      a {
        color: #227ee9;
      }
      a:hover {
        text-decoration: underline;
      }
    }
    .qrcode {
      display: inline-block;
      vertical-align: top;
      margin-left: 330px;
      .img-code {
        width: 90px;
        height: 90px;
      }
    }
  }
}
#btn {
  color: #fff;
  background-color: #1890ff;
  border-color: #1890ff;
  text-shadow: 0 -1px 0 rgba(0, 0, 0, 0.12);
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.045);
}
#btn:hover,
#btn:focus {
  color: #fff !important;
  background-color: #40a9ff !important;
  border-color: #40a9ff !important;
}
</style>
